export default "__VITE_ASSET__B174wwCb__"